import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import AcceptanceArtifactModal from '../AcceptanceArtifactModal';
import { ACCEPTANCE_ARTIFACT_MODAL_MODE } from '../../../constants';

type EditAcceptanceDocumentActionButtonProps = {
  onSuccess?: () => void;
  canManage?: boolean;
};

const EditAcceptanceDocumentActionButton = ({
  onSuccess,
  canManage = true,
}: EditAcceptanceDocumentActionButtonProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const closeModal = () => setModalOpen(false);

  if (!canManage) return null;

  return (
    <>
      <IconButton
        aria-label="Edit document"
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation();
          setModalOpen(true);
        }}
        sx={{ '&.MuiIconButton-root': { p: 0 } }}
      >
        <AppRegistrationIcon color="primary" />
      </IconButton>
      <AcceptanceArtifactModal
        mode={ACCEPTANCE_ARTIFACT_MODAL_MODE.EDIT}
        isOpen={modalOpen}
        onClose={closeModal}
        onSuccess={onSuccess}
      />
    </>
  );
};

export default EditAcceptanceDocumentActionButton;
